import React, { Component } from 'react';
import {storyTemplates} from '../../utils/constants'
import CreateStoryForm from '../../components/CreateStory/CreateStoryForm.jsx'
import { find } from 'lodash'
import { connect } from 'react-redux';
import * as actionCreators from '../../modules/actions/index';
import {withRouter} from 'react-router-dom';
import { isMobile } from '../../utils/deviceInfo';
import './Stories.css';

class StoryCreate extends Component {

	constructor(props) {
    super(props);
			this.state = {
				storyType: null
		  }
    }

		componentWillMount() {
		   this.createStory(this.props.match.params.type)
		}

		componentWillReceiveProps(nextProps){
		  if(this.props.match.params.type!==nextProps.match.params.type){
				this.createStory(nextProps.match.params.type)
		  }
		}

		onStoryPublish(){
			console.log('onStoryPublish')
			this.props.history.push('/home/stories')
		}

		createStory( type ){
			const storyType = find(storyTemplates, { '_id': type });
			if(isMobile)
				this.props.updateNavBar({
					title: storyType.name,
					hasBack: true,
					backTo: '/home/stories/types',
					backButton: '<b>Cancel</b>',
					showNotification: false,
					isBreadCrumbs: false,
					className: 'no-separator'
				});
			this.setState({storyType})
		}

		render() {
			const { storyType } = this.state
	  		return (
					<div>
						<CreateStoryForm closeModal={this.closeModal} storyType={storyType} onStoryPublish={this.onStoryPublish.bind(this)}/>
					</div>
				)
		}
}

const mapDispatchToProps = dispatch => {
	return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(StoryCreate));
